import { motion } from "framer-motion";
import type { StorefrontStat } from "../types";
import { AnimatedCounter } from "./AnimatedCounter";
import { fadeUp, staggerContainer } from "../utils";

type StorefrontStatsProps = {
  stats: StorefrontStat[];
};

export function StorefrontStats({ stats }: StorefrontStatsProps) {
  return (
    <section className="px-4 py-12 sm:px-6 lg:px-8" aria-label="Platform statistics">
      <motion.div
        className="mx-auto grid max-w-6xl gap-4 sm:grid-cols-2 lg:gap-6"
        variants={staggerContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-60px" }}
      >
        {stats.map((stat, i) => (
          <motion.div
            key={stat.id}
            custom={i}
            variants={fadeUp}
            className="group relative overflow-hidden border border-white/60 bg-white/50 p-6 shadow-lg shadow-slate-900/5 backdrop-blur-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
          >
            <div
              className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 bg-gradient-to-br from-violet-400/20 to-cyan-400/20 blur-2xl transition-opacity group-hover:opacity-100"
              aria-hidden
            />
            <p className="text-sm font-medium text-slate-600">{stat.label}</p>
            <p className="mt-2 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              <AnimatedCounter
                value={stat.value}
                prefix={stat.prefix}
                suffix={stat.suffix}
                decimals={stat.value % 1 !== 0 ? 1 : 0}
              />
            </p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
